import { MseStateType } from './state';
import { MseSignupActionType } from './actions';

export const initReducerState = (props: MseStateType): MseStateType => props;

export type ReducerState = ReturnType<typeof initReducerState>;

export function reducer(
  state: MseStateType,
  action: MseSignupActionType,
): MseStateType {
  switch (action.type) {
    case 'SET_NHS_REFERRAL':
      return { ...state, nhsReferral: action.payload };
    case 'SET_FIRST_NAME':
      return { ...state, firstName: action.payload };
    case 'SET_LAST_NAME':
      return { ...state, lastName: action.payload };
    case 'SET_GENDER':
      return { ...state, gender: action.payload };
    case 'SET_HEALTH_CONDITIONS':
      return { ...state, healthConditions: action.payload };
    case 'SET_PREGNANCY':
      return { ...state, pregnancyStatus: action.payload };
    case 'SET_EATING_DISORDER_DIAGNOSIS':
      return { ...state, eatingDisorderDiagnosis: action.payload };
    case 'SET_OPEN_TO_MEDICATION':
      return { ...state, openToMedication: action.payload };
    case 'SET_DIABETES_STATUS':
      return { ...state, diabetesStatus: action.payload };
    case 'SET_DIABETES_MANAGEMENT':
      return { ...state, diabetesManagement: action.payload };
    case 'SET_TYPE_2_DIABETES_MEDICATIONS':
      return { ...state, type2DiabetesMedication: action.payload };
    case 'SET_DIABETES_MEDICATION_PRESCRIBER':
      return { ...state, diabetesMedicationPrescriber: action.payload };
    case 'SET_HAS_DIABETES_DOCTORS_APPOINTMENT':
      return { ...state, hasDiabetesDoctorsAppt: action.payload };
    case 'SET_DIABETES_COMPLICATIONS':
      return { ...state, diabetesComplications: action.payload };
    case 'SET_HAS_OTHER_HEALTH_CONDITIONS':
      return { ...state, hasOtherHealthConditions: action.payload };
    case 'SET_HEALTH_CONDITIONS_TEXT':
      return { ...state, healthConditionsOpenText: action.payload };
    case 'SET_TAKES_MEDICATION':
      return { ...state, takesMedication: action.payload };
    case 'SET_CURRENT_MEDICATION':
      return { ...state, currentMedication: action.payload };
    case 'SET_HAS_ALLERGIES':
      return { ...state, hasAllergies: action.payload };
    case 'SET_ALLERGY_DETAILS':
      return { ...state, allergies: action.payload };
    case 'SET_BIRTHDAY':
      return { ...state, birthday: action.payload };
    case 'SET_ALL':
      return { ...state, ...action.payload };
    case 'SET_DISABILITY_STATUS':
      return { ...state, disabilityStatus: action.payload };
    case 'SET_DISABILITY_TYPE':
      return { ...state, disabilityType: action.payload };
    case 'SET_EMAIL':
      return { ...state, email: action.payload };
    case 'SET_PHONE_NUMBER':
      return { ...state, phoneNumber: action.payload };
    case 'SET_PASSWORD':
      return { ...state, password: action.payload };
    case 'SET_ADDRESS_FIRST_LINE':
      return { ...state, addressFirstLine: action.payload };
    case 'SET_ADDRESS_CITY':
      return { ...state, addressCity: action.payload };
    case 'SET_ADDRESS_POST_CODE':
      return { ...state, addressPostCode: action.payload };
    case 'SET_ETHNICITY':
      return { ...state, ethnicity: action.payload };
    default:
      throw new Error('Invalid action type');
  }
}
